import React from 'react';

import Page from 'app/containers/parts/Page';
import CustomHelmet from 'app/components/commons/CustomHelmet';
import styled from '@emotion/styled';
import RacingCruncherRules from '../myTeams/RacingCruncher/RacingCruncherRules';

const Wrapper = styled.div(props => ({
  paddingLeft: props.theme.spacing.small,
  paddingRight: props.theme.spacing.small
}));

const RacingCruncherRulesPage = () => {
  return (
    <Page>
      <CustomHelmet
        description="Combo Calculator Rules"
        htmlTitle="Combo Calculator Rules"
        title="Combo Calculator Rules"
      />
      <Wrapper>
        <RacingCruncherRules />
      </Wrapper>
    </Page>
  );
};

export default RacingCruncherRulesPage;
